<div [showHideAnimation]="question">
  <p class="ap-mb-spacing-2">{{ question.questionText }}</p>
  <div class="d-flex gap-3">
    <gstar-template-factory />
  </div>
</div>
